<template>
    <div class="qingwu">
        <el-form  label-width="100px" ref="info" :model="info">
          <el-form-item label-width="160px" label="满多少可用" prop="mands" :rules="[{required:true,message:'满多少可用',trigger: 'blur' }]"><el-input type="number" class="spec_group_input" v-model="info.mands" placeholder="0"><template slot="append">元</template></el-input></el-form-item>
          <el-form-item label-width="160px" label="抵扣多少" prop="dik" :rules="[{required:true,message:'抵扣多少',trigger: 'blur' }]"><el-input type="number" class="spec_group_input" v-model="info.dik" placeholder="0"><template slot="append">元</template></el-input></el-form-item>
          <el-form-item label-width="160px" label="领取后有效天数" prop="youxts" :rules="[{required:true,message:'有效天数',trigger: 'blur' }]"><el-input type="number" class="spec_group_input" v-model="info.youxts" placeholder="0"><template slot="append">天</template></el-input></el-form-item>
          <el-form-item label-width="160px" label="类型" prop="leix">
            <el-select v-model="info.leix" placeholder="选择类型">
              <el-option label="全场通用" value="1"></el-option>
              <el-option label="全部商品" value="2"></el-option>
              <el-option label="团购商品" value="3"></el-option>
              <el-option label="全部服务" value="4"></el-option>
              <el-option label="团购服务" value="5"></el-option>
            </el-select>
          </el-form-item>
            <!--<el-form-item label-width="160px" label="APPID" prop="appid" :rules="[{required:true,message:'APPID不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.appid"></el-input></el-form-item>
            <el-form-item label-width="160px" label="APPSECRET" prop="appsecret" :rules="[{required:true,message:'APPSECRET不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.appsecret"></el-input></el-form-item>-->
            <!--<el-form-item label-width="160px" label="备注："><el-tag type="info">新客下单减</el-tag></el-form-item>-->
            <el-form-item label-width="160px">
                <el-button type="primary" @click="submitForm('info')">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          info:{

          },
          upload_headers:{},
          logo:''
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleAvatarSuccess(res) {
            this.info.logo = res.data;
            this.$forceUpdate();
        },
        submitForm:function(e){
            this.$refs[e].validate(res=>{
                if(res){
                    // Http 请求
                    this.$post(this.$api.laoyhfxsdConfig,this.info).then(postRes=>{
                        if(postRes.code == 200){
                            this.$message.success("编辑成功");
                            this.get_alipaypc_config();
                        }else{
                            this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_alipaypc_config(){
            this.$get(this.$api.laoyhfxsdConfig).then(res=>{
                if(res.data != null){
                    this.info  = res.data;
                }
            });
        },
    },
    created() {
        this.get_alipaypc_config();
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>
